import {
  RECURRENCE_DAYS,
  RecurrenceType,
  RecurrenceTypeLabels,
  WEEKDAYS,
} from '@/core/constants/schedule/recurrence';
import moment from 'moment';

export const getRecurrenceLabel = (recurrence) => {
  if (!recurrence) return RecurrenceTypeLabels[RecurrenceType.NONE];

  const frequency = recurrence.frequency?.value ?? recurrence.frequency;
  const interval = recurrence.interval ?? 1;
  const byDay = recurrence.byDay?.map((d) => d.value ?? d) ?? [];
  const until = recurrence.until;
  const repeatTimes = recurrence.repeatTimes ?? recurrence.count;

  if (!frequency) return RecurrenceTypeLabels[RecurrenceType.NONE];

  let label = '';

  switch (frequency) {
    case RecurrenceType.DAILY:
      label =
        interval > 1
          ? `Cada ${interval} días`
          : RecurrenceTypeLabels[RecurrenceType.DAILY];
      break;
    case RecurrenceType.WEEKLY: {
      const isWeekdays =
        byDay.length === 5 && WEEKDAYS.every((d) => byDay.includes(d));

      if (isWeekdays) {
        label = RecurrenceTypeLabels[RecurrenceType.WEEKDAYS];
      } else if (byDay.length) {
        const dayLabels = byDay
          .map((d) => RECURRENCE_DAYS.find((r) => r.id === d)?.label)
          .filter(Boolean)
          .join(', ');
        label =
          interval > 1
            ? `Cada ${interval} semanas los días ${dayLabels}`
            : `Semanal los días ${dayLabels}`;
      } else {
        label =
          interval > 1
            ? `Cada ${interval} semanas`
            : RecurrenceTypeLabels[RecurrenceType.WEEKLY];
      }
      break;
    }
    case RecurrenceType.MONTHLY:
      label =
        interval > 1
          ? `Cada ${interval} meses`
          : RecurrenceTypeLabels[RecurrenceType.MONTHLY];
      break;
    case RecurrenceType.YEARLY:
      label =
        interval > 1
          ? `Cada ${interval} años`
          : RecurrenceTypeLabels[RecurrenceType.YEARLY];
      break;
    default:
      return RecurrenceTypeLabels[RecurrenceType.NONE];
  }

  if (until) {
    label += `. Termina el ${moment(until).format(
      'dddd DD [de] MMMM [del] YYYY'
    )}`;
  } else if (repeatTimes) {
    label += `. Termina después de ${repeatTimes} repeticiones`;
  }

  return label;
};
